import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import WithdrawalPage from './WithdrawalPage';

const WithdrawalPageWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Extract navigation state parameters - match ProfilePage navigation
  const withdrawal_id = location.state?.withdrawal_id || undefined;
  const leave_id = location.state?.leave_id || undefined;
  const children_id = location.state?.children_id || undefined;
  
  console.log('WithdrawalPageWrapper: Navigation state:', location.state);
  console.log('WithdrawalPageWrapper: Extracted params:', { withdrawal_id, leave_id, children_id });
  
  return (
    <WithdrawalPage 
      navigate={navigate}
      withdrawal_id={withdrawal_id}
      leave_id={leave_id}
      children_id={children_id}
    />
  );
};

export default WithdrawalPageWrapper;
